import {
  Button as ButtonMui,
  ButtonProps as ButtonMuiProps,
} from "@mui/material";
import { theme } from "../../themes/theme";

export enum ButtonVariant {
  outlined = "outlined",
  primary = "primary",
  text = "text",
  area = "area",
  delete = "delete",
  outlinedRed = "outlinedRed",
  outlinedWhite = "outlinedWhite",
}

export type ButtonProps = ButtonMuiProps & {
  buttonVariant?: ButtonVariant;
  textAlign?: "left" | "center" | "right";
  boldText?: boolean;
};

export const Button = (props: ButtonProps) => {
  const { buttonVariant = ButtonVariant.primary, ...rest } = props;

  if (buttonVariant === ButtonVariant.primary)
    return <ButtonMui variant="contained" color="secondary" {...rest} />;

  if (buttonVariant === ButtonVariant.text)
    return <ButtonMui variant="text" color="secondary" {...rest} />;

  if (buttonVariant === ButtonVariant.outlined)
    return <ButtonMui variant="outlined" color="secondary" {...rest} />;

  if (buttonVariant === ButtonVariant.delete)
    return <ButtonMui variant="contained" {...rest} />;

  if (buttonVariant === ButtonVariant.outlinedRed)
    return (
      <ButtonMui variant="outlined" style={{ borderRadius: 12 }} {...rest} />
    );

  if (buttonVariant === ButtonVariant.outlinedWhite)
    return (
      <ButtonMui
        variant="outlined"
        color="secondary"
        sx={{
          background: theme.color.white,
          borderColor: theme.color.neutral[300],
          justifyContent: "flex-start",
          textAlign: props.textAlign,
          fontWeight: props.boldText ? 700 : 400,
          fontSize: theme.fontSize.body16,
          padding: `${theme.spacing.m} ${theme.spacing.lxx}`,
          "&:hover": {
            background: theme.color.neutral[100],
          },
        }}
        {...rest}
      />
    );

  return <ButtonMui color="secondary" {...rest} />;
};
